module.exports = new __parcel__URL__("medal.bff92450.svg").toString();